var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/hooks/use-get-widget-container.hook.ts
import { useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";

// src/utils/get-observability-context.ts
var getObservabilityContext = (context) => __spreadProps(__spreadValues({}, context), {
  tags: __spreadValues({
    dependentModule: "masonry",
    supportTeam: "masonry-web"
  }, context == null ? void 0 : context.tags)
});

// src/utils/get-widget-container.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_WIDGET_CONTAINER = "get_widget_container";
var getWidgetContainer = (appId, version, apiParams, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch.fetch(
    {
      message_type: GET_WIDGET_CONTAINER,
      info: __spreadValues({
        type: appId,
        version
      }, apiParams && { api_params: apiParams })
    },
    {
      errorContext
    }
  );
});

// src/hooks/use-get-widget-container.hook.ts
var GET_WIDGET_CONTAINER2 = "get_widget_container";
var useGetWidgetContainer = (appId, version, apiParams, errorContext = {}) => {
  const queryClient = useQueryClient();
  useEffect(
    () => () => {
      queryClient.invalidateQueries([GET_WIDGET_CONTAINER2, appId, version]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return useQuery(
    [GET_WIDGET_CONTAINER2, appId, version],
    () => getWidgetContainer(
      appId,
      version,
      apiParams,
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - get widget container api error",
        tags: __spreadValues({
          container: appId,
          apiVersion: version
        }, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    )
  );
};

// src/hooks/use-get-widget-data.hook.ts
import { useEffect as useEffect2 } from "react";
import { useQuery as useQuery2, useQueryClient as useQueryClient2 } from "react-query";

// src/utils/get-widget-data.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
var GET_WIDGET_DATA = "get_widget_data";
var getWidgetData = (params, version, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch2.fetch(
    {
      message_type: GET_WIDGET_DATA,
      info: __spreadProps(__spreadValues({}, params), {
        version
      })
    },
    {
      errorContext
    }
  );
});

// src/utils/normalize-paramters.ts
var normalizeParams = ({
  params = []
}) => params.reduce(
  (paramObj, { key, value }) => __spreadProps(__spreadValues({}, paramObj), { [key]: value }),
  {}
);

// src/hooks/use-get-widget-data.hook.ts
var GET_WIDGET_DATA2 = "get_widget_data";
var useGetWidgetData = (widget, version, errorContext = {}) => {
  const { id: widgetId, links } = widget;
  const queryClient = useQueryClient2();
  const linkDetails = links.find(({ rel }) => rel === "data");
  useEffect2(
    () => () => {
      queryClient.invalidateQueries([GET_WIDGET_DATA2, widgetId, version]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return useQuery2(
    [GET_WIDGET_DATA2, widgetId, version],
    () => getWidgetData(
      normalizeParams({ params: linkDetails == null ? void 0 : linkDetails.params }),
      version,
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - get widget data api error",
        tags: __spreadValues({
          widgetId,
          apiVersion: version
        }, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    ),
    {
      onSuccess: (data) => {
        if (!(data == null ? void 0 : data.attributes)) {
          console.warn(
            `[Masonry]: No attributes returned from api get_widget_data for widget id %c'${data.id}'`
          );
        }
      }
    }
  );
};

// src/hooks/use-post-dismiss-widget.hook.ts
import { useQuery as useQuery3 } from "react-query";

// src/utils/post-widget-dismiss.ts
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
var postWidgetDismiss = (messageType, params, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch3.fetch(
    {
      message_type: messageType,
      info: __spreadValues({}, params)
    },
    {
      errorContext
    }
  );
});

// src/hooks/use-post-dismiss-widget.hook.ts
var usePostDismissWidget = (dismissed, link, errorContext = {}) => {
  const { href = "", params } = link || {};
  useQuery3(
    [href],
    () => postWidgetDismiss(
      href,
      normalizeParams({ params }),
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - post dismiss widget api error",
        tags: __spreadValues({}, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    ),
    { enabled: dismissed }
  );
};

// src/hooks/use-generate-pdf-report.hook.ts
import { useQuery as useQuery4 } from "react-query";

// src/utils/get-container-pdf.ts
import { SocketAsFetch as SocketAsFetch4 } from "@leagueplatform/socket-as-fetch";
var getContainerPDF = (messageType, params, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch4.fetch(
    {
      message_type: messageType,
      info: __spreadValues({}, params)
    },
    {
      errorContext
    }
  );
});

// src/hooks/use-generate-pdf-report.hook.ts
var GET_CONTAINER_PDF = "get_container_pdf";
var useGeneratePDFReport = (generatePDF, {
  containerId: container_id,
  filename,
  templateId: template_id,
  version
}, errorContext = {}) => useQuery4(
  [GET_CONTAINER_PDF],
  () => getContainerPDF(
    GET_CONTAINER_PDF,
    __spreadValues({
      container_id,
      filename,
      version
    }, template_id && { template_id }),
    getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
      errorName: "Masonry - get container pdf widget api error",
      tags: __spreadValues({}, (errorContext == null ? void 0 : errorContext.tags) || {})
    }))
  ),
  { enabled: generatePDF }
);

// src/hooks/use-invalidate-get-container-request.hook.ts
import { useCallback } from "react";
import { useQueryClient as useQueryClient3 } from "react-query";
var useInvalidateContainerRequest = (appId, version) => {
  const queryClient = useQueryClient3();
  return useCallback(() => {
    queryClient.invalidateQueries([GET_WIDGET_CONTAINER2, appId, version]);
  }, [appId, version, queryClient]);
};

// src/hooks/use-invalidate-get-widget-request.hook.ts
import { useCallback as useCallback2 } from "react";
import { useQueryClient as useQueryClient4 } from "react-query";
var useInvalidateGetWidgetRequest = (widgetId, version) => {
  const queryClient = useQueryClient4();
  return useCallback2(() => {
    queryClient.invalidateQueries([GET_WIDGET_DATA2, widgetId, version]);
  }, [widgetId, version, queryClient]);
};

// src/types/widget-data.ts
var Orientation = /* @__PURE__ */ ((Orientation2) => {
  Orientation2["VERTICAL"] = "vertical";
  Orientation2["HORIZONTAL"] = "horizontal";
  Orientation2["GRID"] = "grid";
  return Orientation2;
})(Orientation || {});
var SupportedMedia = /* @__PURE__ */ ((SupportedMedia2) => {
  SupportedMedia2["MOBILE"] = "mobile";
  SupportedMedia2["TABLET"] = "tablet";
  SupportedMedia2["LAPTOP"] = "laptop";
  SupportedMedia2["DESKTOP"] = "desktop";
  return SupportedMedia2;
})(SupportedMedia || {});

// src/types/widget-types.ts
var WidgetType = /* @__PURE__ */ ((WidgetType2) => {
  WidgetType2["SMALL_VISUAL_CARD"] = "text_with_small_image";
  WidgetType2["LARGE_VISUAL_CARD"] = "text_with_large_image";
  WidgetType2["TEXT_WITH_CTA_CARD"] = "text_with_button";
  WidgetType2["CAROUSEL"] = "carousel";
  WidgetType2["HEALTH_JOURNEY"] = "health_journey";
  WidgetType2["WELCOME_BANNER"] = "welcome_banner";
  WidgetType2["HERO_BANNER"] = "heroBanner";
  WidgetType2["PRODUCT_CAROUSEL"] = "product_carousel";
  WidgetType2["NOTIFICATION_BANNER"] = "notification_banner";
  WidgetType2["NOTIFICATION_CARD"] = "notification_card";
  WidgetType2["XS_VISUAL_CARD"] = "xs_visual_card";
  WidgetType2["VERTICAL_STACK_XS"] = "vertical_stack_xs";
  WidgetType2["IMAGE_FOOTER"] = "image_footer";
  WidgetType2["CUSTOM_COMPONENT"] = "custom_component";
  WidgetType2["PROGRESS_BAR"] = "progress_bar";
  WidgetType2["PROGRESS_RING"] = "progress_ring";
  WidgetType2["TWO_UP_CARD"] = "2_up_card";
  WidgetType2["SECTION_HEADER"] = "section_header";
  WidgetType2["STACK"] = "stack";
  WidgetType2["GENERIC_CAROUSEL"] = "genericCarousel";
  WidgetType2["METRIC_CARD"] = "metricCard";
  return WidgetType2;
})(WidgetType || {});

// src/__mocks__/get-widget-container.mocks.ts
var getWidgetContainerMock = {
  type: "b2b_care_homepage",
  widgets: [
    {
      id: "6739f94fca803fd3fb6db4b11db7302a",
      type: "section_header" /* SECTION_HEADER */,
      name: "How can we help you",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "6739f94fca803fd3fb6db4b11db7302a"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "821ab100fcb5605d683fff1779a017a8",
      type: "text_with_large_image" /* LARGE_VISUAL_CARD */,
      name: "how can we help Items",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "821ab100fcb5605d683fff1779a017a8"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "04e87b5f290fd3063af7c5c5af5b4e00",
      type: "stack" /* STACK */,
      name: "Care Providers List",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "04e87b5f290fd3063af7c5c5af5b4e00"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "e5a5bc5ebb5cd237e425efdc9dcf4a1f",
      type: "carousel" /* CAROUSEL */,
      name: "Recommended QuickActions Menu Items",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "e5a5bc5ebb5cd237e425efdc9dcf4a1f"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    }
  ]
};

// src/__mocks__/get-widget-container-v2.mocks.ts
var getWidgetContainerV2Mock = {
  type: "homescreen",
  widgets: [
    {
      id: "current_default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_default"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "current_default_with_loading",
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_default_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "current_custom_component",
      custom_type: "health_journey",
      module: "health_journey",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_custom_component"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 4. (NEW) Current custom component with loading
    {
      id: "current_custom_component_with_loading",
      // custom_type: 'health_journey',
      module: "health_journey",
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_custom_component_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 5. (NEW) Custom component without loading
    {
      id: "new_custom_component_without_loading",
      // custom_type: 'health_journey',
      module: "health_journey",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "new_custom_component_without_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 6. (NEW) Custom component with loading
    {
      id: "new_custom_component_with_loading",
      module: "health_journey",
      // custom_type: 'health_journey',
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "new_custom_component_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    }
  ]
};

// src/__mocks__/get-widget-data.mocks.ts
var getWidgetDataMock = {
  id: "6739f94fca803fd3fb6db4b11db7302a",
  type: "section_header",
  product_identifier: "get_care",
  attributes: {
    heading: "How can we help you?"
  },
  links: [
    {
      rel: "self",
      type: "GET",
      href: "get_widget_data",
      params: [
        {
          key: "widget_id",
          value: "6739f94fca803fd3fb6db4b11db7302a"
        },
        {
          key: "version",
          value: "1"
        }
      ],
      protocol: "websocket"
    }
  ],
  traits: {}
};

// src/__mocks__/get-widget-data-v2.mocks.ts
var getWidgetDataV2DefaultComponentMock = {
  id: "new_default_component_mock",
  type: "text_with_large_image",
  product_identifier: "get care",
  attributes: {
    title: "cool test custom component",
    description: "cool test custom component",
    image: "https://www.searchenginejournal.com/wp-content/uploads/2022/06/image-search-1600-x-840-px-62c6dc4ff1eee-sej.png"
  },
  links: [
    {
      rel: "data",
      type: "GET",
      href: "get_widget_data",
      params: [
        {
          key: "widget_id",
          value: "new_default_component_mock"
        },
        {
          key: "version",
          value: "1"
        }
      ],
      protocol: "websocket"
    }
  ],
  traits: {}
};
var getWidgetDataV2CustomComponentMock = {
  id: "new_custom_component_mock",
  type: "health_journey",
  module: "journey",
  product_identifier: "get care",
  attributes: {
    title: "cool test custom component",
    description: "cool test custom component",
    image: "https://www.searchenginejournal.com/wp-content/uploads/2022/06/image-search-1600-x-840-px-62c6dc4ff1eee-sej.png"
  },
  links: [
    {
      rel: "data",
      type: "GET",
      href: "get_widget_data",
      params: [
        {
          key: "widget_id",
          value: "new_custom_component_mock"
        },
        {
          key: "version",
          value: "1"
        }
      ],
      protocol: "websocket"
    }
  ]
};
export {
  GET_WIDGET_CONTAINER2 as GET_WIDGET_CONTAINER,
  GET_WIDGET_DATA2 as GET_WIDGET_DATA,
  Orientation,
  SupportedMedia,
  WidgetType,
  getObservabilityContext,
  getWidgetContainerMock,
  getWidgetContainerV2Mock,
  getWidgetDataMock,
  getWidgetDataV2CustomComponentMock,
  getWidgetDataV2DefaultComponentMock,
  useGeneratePDFReport,
  useGetWidgetContainer,
  useGetWidgetData,
  useInvalidateContainerRequest,
  useInvalidateGetWidgetRequest,
  usePostDismissWidget
};
//# sourceMappingURL=index.js.map